import request from '../../utils/request';

export interface IConversation {
  id: number;
  title: string;
  updated_date: string;
  is_active: boolean;
}

export interface ISqlQueryAudit {
  sql: string;
  row_count: number;
  capped: boolean;
  input_tokens: number;
  output_tokens: number;
  executed_at: string;
}

export interface IMessage {
  id: number;
  role: 'user' | 'assistant';
  content: string;
  sql_queries?: string;
  input_tokens_used?: number;
  output_tokens_used?: number;
  created_date: string;
}

export interface IToolCall {
  sql: string;
  description: string;
  row_count?: number;
  capped?: boolean;
}

class AiChatService {
  getConversations = async (
    page = 1,
    limit = 20
  ): Promise<{ data: IConversation[]; count: number; page: number; limit: number }> => {
    const res = await request({
      url: '/ai-chat/conversations',
      method: 'GET',
      params: { page, limit },
    });
    return res.data.body.data;
  };

  getMessages = async (
    id: number
  ): Promise<{ conversation: IConversation; messages: IMessage[] }> => {
    const res = await request({
      url: `/ai-chat/conversations/${id}/messages`,
      method: 'GET',
    });
    return res.data.body.data;
  };

  deleteConversation = async (id: number): Promise<void> => {
    await request({ url: `/ai-chat/conversations/${id}`, method: 'DELETE' });
  };
}

export default new AiChatService();
